module.exports = __webpack_public_path__ + "static/media/connect-grey.6af446b5.svg";